/* ========== STOCK ALERT COMPONENT ========== */

  class StockAlert extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Actualizar en load inicial
      this.updateInitialStock();

      // Escuchar cambios de variante - Múltiples eventos
      this.setupVariantListeners();
    }

    updateInitialStock() {
      // Si ya tiene data-stock, usarlo
      const initialStock = this.dataset.stock;
      if (initialStock) {
        this.displayStock(parseInt(initialStock));
      }
    }

    setupVariantListeners() {
      // Método 1: Event listener para variant:change (temas modernos)
      document.addEventListener('variant:change', (event) => {
        if (event.detail && event.detail.variant) {
          this.displayStock(event.detail.variant.inventory_quantity);
        }
      });

      // Método 2: Input change listeners (universal)
      document.addEventListener('change', (event) => {
        if (event.target.name === 'id' ||
            event.target.dataset.variantId ||
            event.target.classList.contains('product-form__input')) {
          this.handleVariantChange(event.target);
        }
      });

      // Método 3: Select change (backup)
      const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', (event) => {
          this.handleVariantChange(event.target);
        });
      });

      // Método 4: Evento VARIANT_CHANGE del theme Tinker (canónico)
      // Resuelve el bug donde handleVariantChange recibe selector.value="5+1 vainas (24g)"
      // en vez del variant ID numérico. <product-variants> tiene currentVariant ya hidratada
      // post-Section Rendering API por data-js-variant-data + data-update-block="variant-data".
      const bindProductVariants = () => {
        document.querySelectorAll('product-variants').forEach((pv) => {
          if (pv.dataset.stockAlertBound === 'true') return;
          pv.dataset.stockAlertBound = 'true';
          pv.addEventListener('VARIANT_CHANGE', () => {
            const v = pv.currentVariant;
            if (!v) return;
            // Shopify no publica inventory_quantity en el JSON de la variante: usar el mapa por ID que imprime Liquid (data-stocks)
            const mapa = this.stockMap();
            if (mapa && Object.prototype.hasOwnProperty.call(mapa, String(v.id))) {
              this.displayStock(mapa[String(v.id)]);
            } else if (typeof v.inventory_quantity === 'number') {
              this.displayStock(v.inventory_quantity);
            } else if (v.available === false) {
              this.displayStock(0);
            }
          });
        });
      };
      bindProductVariants();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindProductVariants);
      }
    }

    stockMap() {
      // data-stocks="123:4,456:0" → { '123': 4, '456': 0 }
      if (!this.dataset.stocks) return null;
      const m = {};
      this.dataset.stocks.split(',').forEach((par) => {
        const [id, q] = par.split(':');
        if (id) m[id.trim()] = parseInt(q, 10) || 0;
      });
      return m;
    }

    handleVariantChange(selector) {
      const variantId = selector.value;
      const mapa = this.stockMap();
      if (mapa && Object.prototype.hasOwnProperty.call(mapa, String(variantId))) {
        this.displayStock(mapa[String(variantId)]);
        return;
      }

      // Buscar variant data
      if (window.product && window.product.variants) {
        const variant = window.product.variants.find(v => v.id == variantId);
        if (variant) {
          this.displayStock(variant.inventory_quantity);
        }
      }

      // Fallback: buscar en DOM data
      const variantData = document.querySelector(`[data-variant-id="${variantId}"]`);
      if (variantData && variantData.dataset.stock) {
        this.displayStock(parseInt(variantData.dataset.stock));
      }
    }

    displayStock(quantity) {
      const stockText = this.querySelector('.stock-text');

      if (!stockText) return;

      // Modo "disponible" - lógica actualizada con threshold configurable
      if (this.dataset.mode === 'available') {
        const threshold = parseInt(this.dataset.threshold) || 3;
        if (quantity <= threshold && quantity > 0) {
          // Mostrar cantidad específica en rojo cuando quedan threshold o menos
          this.style.display = 'flex';
          this.classList.remove('stock-available');
          this.classList.add('stock-alert--critical');

          const message = 'Pocas unidades'; // sin cantidad exacta (Nico, 2-oct-2026)
          stockText.textContent = message;
        } else if (quantity > threshold) {
          // Mostrar "En stock" en verde cuando hay más del threshold
          this.style.display = 'flex';
          this.classList.remove('stock-alert--critical');
          this.classList.add('stock-available');
          stockText.textContent = 'En stock';
        } else {
          // Ocultar cuando no hay stock
          this.style.display = 'none';
        }
        return;
      }

      // Lógica original para stock bajo (6 o menos)
      if (quantity <= 6 && quantity > 0) {
        this.style.display = 'flex';

        // Limpiar clases anteriores
        this.classList.remove('stock-alert--critical', 'stock-alert--low', 'stock-alert--medium', 'stock-available');

        let message = '';
        let alertClass = '';

        // Lógica de mensajes y colores
        if (quantity === 1) {
          message = 'Pocas unidades';
          alertClass = 'stock-alert--critical';
        } else if (quantity <= 4) {
          message = 'Pocas unidades';
          alertClass = 'stock-alert--low';
        } else if (quantity <= 6) {
          message = 'Pocas unidades';
          alertClass = 'stock-alert--medium';
        }

        // Aplicar mensaje y clase
        stockText.textContent = message;
        this.classList.add(alertClass);

        // Update data attribute
        this.dataset.stock = quantity;

      } else {
        // Ocultar si no hay stock bajo
        this.style.display = 'none';
      }
    }

    // Método público para actualizar manualmente
    updateStock(quantity) {
      this.displayStock(quantity);
    }
  }

  // Registrar el custom element
  if (!customElements.get('stock-alert-custom')) {
    customElements.define('stock-alert-custom', StockAlert);
  }

  // Inicializar cuando DOM esté listo
  document.addEventListener('DOMContentLoaded', function() {
    // Forzar inicialización de todos los stock alerts
    const stockAlerts = document.querySelectorAll('stock-alert-custom');
    stockAlerts.forEach(alert => {
      if (alert.dataset.stock) {
        alert.updateStock(parseInt(alert.dataset.stock));
      }
    });
  });/* bust-1779717562 */
